export const siteName = "Valmeego";
export const siteTagline = "Locally and beyond";
export const siteTitle = `${siteName} - ${siteTagline}`;

export const awsResources =
  "https://valmeego-live-resources.s3.eu-west-1.amazonaws.com/";
